import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { EmailSidebarType } from '../../views/EmailV2/EmailSidebar/models'

import { RootState } from '../store'

interface DisplayedEmailSidebar {
  type: EmailSidebarType
  title: string
  icon: string
}

interface EmailSidebarState {
  displayedSidebar: DisplayedEmailSidebar | null
}

const initialState: EmailSidebarState = {
  displayedSidebar: null,
}

export const emailSidebarSlice = createSlice({
  name: 'emailSidebar',
  initialState,
  reducers: {
    displayEmailSidebar: (state, action: PayloadAction<DisplayedEmailSidebar>) => {
      state.displayedSidebar = action.payload
    },
    hideEmailSidebar: (state) => {
      state.displayedSidebar = null
    },
    resetEmailSidebar: () => initialState,
  },
})

export const { displayEmailSidebar, hideEmailSidebar, resetEmailSidebar } = emailSidebarSlice.actions

export const selectDisplayedEmailSidebar = (state: RootState) => state.emailHub.emailSidebar.displayedSidebar
